module.exports = __webpack_public_path__ + "static/policy-confirm-cf47780fbde799a60d571621abe0bce1.png";